module.exports = __webpack_public_path__ + "static/img/200181.0755580b.png";